var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "swap-item-button",
      class: _vm.classes,
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("span", { staticClass: "swap-item-icon-container" }, [
        _c(
          "svg",
          {
            staticClass: "swap-item-icon",
            class: "swap-item-icon--" + this.icon,
            style: { height: _vm.iconSize },
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "-869.182 2717.125 14.364 19.75"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Path_271",
                "data-name": "Path 271",
                d:
                  "M7.182,4.489V7.182l3.591-3.591L7.182,0V2.693A7.2,7.2,0,0,0,0,9.875a8.025,8.025,0,0,0,1.077,3.86l1.347-1.347A4.76,4.76,0,0,1,1.8,9.875,5.4,5.4,0,0,1,7.182,4.489Zm6.1,1.526L11.94,7.361a5.78,5.78,0,0,1,.628,2.514,5.4,5.4,0,0,1-5.386,5.386V12.568L3.591,16.159,7.182,19.75V17.057a7.2,7.2,0,0,0,7.182-7.182A8.025,8.025,0,0,0,13.286,6.015Z",
                transform: "translate(-869.182 2717.125)"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.text,
              expression: "!!text"
            }
          ],
          staticClass: "swap-item-text"
        },
        [_vm._v(_vm._s(_vm.text))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bfaa0dd", { render: render, staticRenderFns: staticRenderFns })
  }
}